import App from 'spa/App'
import React from 'react'
import { createRoot } from 'react-dom/client'
import tagManager from 'spa/config/gtm'
import { HelmetProvider } from 'react-helmet-async'

tagManager()

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('app')
  if (container) {
    const root = createRoot(container)
    root.render(
      <HelmetProvider>
        <App />
      </HelmetProvider>
    )
  }
})
